import Vue from 'vue';
import VueRouter from 'vue-router';
import Landing from '@views/Landing/Landing.vue';
import store from '@store';
import { stopListeningForListChange } from "@utils/FirebaseListeners";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: Landing
  },
  {
    path: '/updates',
    name: 'Updates',
    component: () => import(/* webpackChunkName: "updates" */ '@views/Updates/Updates.vue')
  },
  {
    path: '/updates/:updateId',
    name: 'Update',
    component: () => import(/* webpackChunkName: "update" */ '@views/Update/Update.vue')
  },
  {
    path: '/*',
    name: 'App',
    component: () => import(/* webpackChunkName: "linkslist" */ '@views/App/App.vue')
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.afterEach((to, from) => {
  // from.name will be null when loading the first page (e.g. after a pay refresh)
  if (from.name === null || to.path === from.path) {
    return;
  }

  stopListeningForListChange();
  // Clear links so that if we're swapping to a list that has fewer links than is currently displayed, then we won't see links from the old list
  store.dispatch('clearLinks').then(() => {
    const id = to.path.replace('/', '')
    if (id !== 'app') {
      store.dispatch('urlString', id); // This will set up the listener for the next list ID
    }
  });
})

export default router;
